import React, { FC } from 'react';
import './separator.scss';

export const BigLineSeparator: FC = () => <div className="separator-big" />;

export const SmallLineSeparator: FC = () => <div className="separator" />;
